function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useContext, useEffect } from "react";
import { BreakpointsContext } from "../../Breakpoints/BreakpointsProvider";
var sizes = [
    's',
    'm',
    'l',
    'xl'
];
var getDirectionalSize = function(providedSizes, size) {
    var direction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (providedSizes.includes(size)) {
        return size;
    }
    var sizeIndex = sizes.indexOf(size);
    if (sizeIndex === 0 && direction < 0 || sizeIndex >= sizes.length - 1 && direction > 0) {
        return false;
    }
    return getDirectionalSize(providedSizes, sizes[sizeIndex + direction]);
};
var mergeCols = function(cols) {
    var providedSizes = Object.keys(cols);
    return sizes.reduce(function(_cols, size) {
        var smallerSize = getDirectionalSize(providedSizes, size, -1);
        if (smallerSize) {
            return _objectSpread({}, _cols, _defineProperty({}, size, cols[smallerSize]));
        }
        var largerSize = getDirectionalSize(providedSizes, size, 1);
        if (largerSize) {
            return _objectSpread({}, _cols, _defineProperty({}, size, cols[largerSize]));
        }
        return _cols;
    }, {
        s: 1,
        m: 1,
        l: 1,
        xl: 1
    });
};
export var useColCount = function(cols, setColCount, containerWidth) {
    var ref = useContext(BreakpointsContext), m = ref.m, l = ref.l, xl = ref.xl;
    useEffect(function() {
        if (typeof cols !== 'number') {
            if (!containerWidth) {
                return;
            }
            var mergedCols = mergeCols(cols);
            if (containerWidth < m) {
                setColCount(mergedCols.s);
            } else if (containerWidth < l) {
                setColCount(mergedCols.m);
            } else if (!xl || containerWidth < xl) {
                setColCount(mergedCols.l);
            } else {
                setColCount(mergedCols.xl);
            }
        } else {
            setColCount(cols);
        }
    }, [
        containerWidth,
        m,
        l,
        xl,
        cols
    ]);
};
export default useColCount;
